import React from 'react';
import './Dashboard.css';

function Dashboard() {
  return (
    <div className="dashboard-container">
      <h1>Dashboard</h1>
      {/* Add dashboard content here */}
    </div>
  );
}

export default Dashboard;
